module.exports = __webpack_public_path__ + "static/img/icon1.081427b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon1.png
// module id = E/c3
// module chunks = 1